<template>
  <Input v-model="keyWord">
    <span slot="prepend">万能搜索</span>
    <Button
      slot="append"
      icon="ios-search"
      @click="handleSerchByKword"
    ></Button>
  </Input>
</template>

<script>
export default {
  data() {
    return {
      keyWord: ""
    };
  },
  methods: {
    handleSerchByKword() {
      this.$emit("getKword", this.keyWord);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseKeyword.vue